<button type="submit"
  class="p-2 px-6 flex-none rounded-[10px] bg-gradient-to-r from-primary to-semiPrimary text-white hover:bg-primary/80"
>
  <ng-content></ng-content>
</button>
